import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";
import {
  Send,
  Mail,
  Users,
  UserPlus,
  GraduationCap,
  BookOpen,
  Loader2,
  ChevronDown,
  Sparkles,
  Target,
  TrendingUp,
  Clock,
} from "lucide-react";
import './MailToNonPaidUser.css'

function MailToNonPaidUsers({ match }) {
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [sendVia, setSendVia] = useState("");
  const [loader, setLoader] = useState(false);

  // Stats data
  const [stats, setStats] = useState({
    totalNonPaidUsers: 1,
    recentlyJoined: 0,
    engagementRate: 0,
    conversionPotential: 0,
  });

  useEffect(() => {
    // You can fetch actual stats here
    setStats({
      totalNonPaidUsers: 2345,
      recentlyJoined: 456,
      engagementRate: 68,
      conversionPotential: 32,
    });
  }, []);

  const handleSubmit = async () => {
    try {
      if (value && subject && sendVia) {
        setLoader(true);
        let payload = {
          template: value,
          subject: subject,
          sendVia: sendVia,
        };
        const userData = await api.sendMailToNonPaidUser(payload);
        if (userData.success) {
          alert(userData.message);
          setLoader(false);
        } else {
          alert("Something went wrong, email not sent ");
          setLoader(false);
        }
      } else {
        setLoader(false);
        alert("Please insert fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  const handleSubmitStartEdu = async () => {
    try {
      setLoader(true);
      const userData = await api.sendmailToNonPaidStartLearn();
      if (userData.success) {
        alert(userData.message);
        setLoader(false);
      } else {
        alert("Something went wrong ");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong ");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>

      <div className="email-dashboard">
        {/* Header with integrated stats */}
        <div className="dashboard-header-container">
          <div className="header-main">
            <div className="header-icon">
              <UserPlus size={22} />
            </div>
            <div className="content-headers">
              <h1>Send Mail To Non-Paid Users</h1>
              <p>Engage with free users and encourage them to upgrade</p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon stat-icon-1">
                <Users size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.totalNonPaidUsers.toLocaleString()}</h3>
                <p>NON-PAID USERS</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-2">
                <Clock size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.recentlyJoined.toLocaleString()}</h3>
                <p>RECENTLY JOINED</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-3">
                <TrendingUp size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.engagementRate}%</h3>
                <p>ENGAGEMENT RATE</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-4">
                <Target size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.conversionPotential}%</h3>
                <p>CONVERSION POTENTIAL</p>
              </div>
            </div>
          </div>
        </div>

        {/* Email Form Card */}
        <div className="email-card">
          <div className="card-headers">
            <div className="card-icon">
              <Send size={20} />
            </div>
            <h2>Compose Engagement Email</h2>
          </div>

          <div className="form-group">
            <label>
              <Mail size={16} />
              Email Subject
            </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Subject..."
            />
          </div>

          <div className="form-group">
            <label>
              <Send size={16} />
              Send Via
            </label>
            <div className="select-wrapper">
              <select
                name="category"
                onChange={(e) => setSendVia(e.target.value)}
                className="form-control"
              >
                <option value="">Send Via</option>
                <option value="noreply">noreply@waqarzaka.net</option>
                <option value="info">info@waqarzaka.net</option>
              </select>
              <div className="select-arrow">
                <ChevronDown size={20} />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>
              <Sparkles size={16} />
              Email Content
            </label>
            <div className="editor-container">
              <ReactQuill
                placeholder="Add Email description"
                modules={Editor}
                theme="snow"
                value={value}
                onChange={setValue}
              />
            </div>
          </div>

          <div className="button-group">
            <button onClick={handleSubmit} className="btn btn-primary">
              <Send size={18} />
              Send Mail to Non-Paid Users
            </button>

            <button
              onClick={handleSubmitStartEdu}
              className="btn secondaries-btn"
            >
              <GraduationCap size={18} />
              Send Mail of Start Educational Journey
            </button>
          </div>
        </div>

        {/* Loader */}
        {loader && (
          <div className="loader-overlay">
            <div className="loader-content">
              <Loader2 size={48} className="loader-spinner" />
              <p className="loader-text">Sending engagement emails...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MailToNonPaidUsers;
